import React, { useState } from "react";

import Modal from "Components/Common/Modal";

export const ModalContext = React.createContext({
  open: false,
  setOpen: () => {},
  closeModal: () => {},
});

const ModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({});

  const openModal = (config) => {
    setModalConfig(config);
    setOpen(true);
  };

  const onDismiss = () => {
    setOpen(false);
    if (modalConfig.onDismiss) modalConfig.onDismiss();
  };

  const onSubmit = () => {
    setOpen(false);
    if (modalConfig.onSubmit) modalConfig.onSubmit();
  };

  const contextValue = {
    open,
    setOpen,
    openModal,
    closeModal: () => onDismiss(),
  };

  return (
    <>
      <ModalContext.Provider value={contextValue}>
        <Modal
          {...modalConfig}
          open={open}
          onDismiss={onDismiss}
          onSubmit={onSubmit}
        >
          {modalConfig.children}
        </Modal>
        {children}
      </ModalContext.Provider>
    </>
  );
};

export default ModalProvider;
